import AsyncPage from 'pages/AsyncPage'
import { clearSuggestions } from 'actions/mentions'
import universal from 'react-universal-component'
const component = universal(props => import('./CreateGroupMembersPage.js'))

// export default new AsyncPage({
//   pageComponent: component
// })

class AsyncCreateGroupMembersPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    dispatch(clearSuggestions())
  }
}

export default new AsyncCreateGroupMembersPage()
